// extracted by mini-css-extract-plugin
export var filterButton = "_ms-1";
export var filtersContainer = "_ms-0";